import { useEffect, useState } from "react";

/**
 * A placeholder that types itself out, one hint after another: the topbar
 * search's animation, shared. Paused while the input has focus (the coach is
 * typing their own) and while the tab is hidden, so it isn't re-rendering
 * every 48ms in a backgrounded app.
 */
export function useTypedHint(hints, paused = false, { speed = 48, hold = 2000 } = {}) {
  const [idx, setIdx] = useState(0);
  const [typed, setTyped] = useState("");
  const list = Array.isArray(hints) ? hints : [];
  const key = list.join("\u0001");
  useEffect(() => { setIdx(0); }, [key]);
  useEffect(() => {
    if (paused || list.length === 0) return;
    const hint = list[idx % list.length] || "";
    let i = 0; setTyped("");
    let cycleT = null;
    const iv = setInterval(() => {
      if (typeof document !== "undefined" && document.hidden) return;
      i++; setTyped(hint.slice(0, i));
      if (i >= hint.length) { clearInterval(iv); cycleT = setTimeout(() => setIdx(x => (x + 1) % list.length), hold); }
    }, speed);
    return () => { clearInterval(iv); if (cycleT) clearTimeout(cycleT); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idx, paused, key, speed, hold]);
  return typed;
}

export default useTypedHint;
